import http from "./client";
import IGroupChat from "../typings/IGroupChat";

export interface IGetChatRoomQueryParams {
  search?: string;
  page?: number;
  limit?: number;
  course_id?: number | string;
  curator?: number | string  | 'none'; // id куратора
  tags?: Array<number | string>; // массив id тегов
  exclude_tags?: Array<number | string>; // массив id тегов
  exclude_document?: string | number;
  by_room?: number;
  lesson?: {
    id : number | string;
    status: 'inqueue' | 'done' | 'none'
  }
  type?: 'file';
  fileId?: string;
}

interface IChatRoomResponse<T> {
  success: boolean;
  errorMessage?: string;
  paginator?: {
    limit: number;
    page: number;
    pageCount: number;
    totalItemCount: number;
  },
  metaData?: any;
  data?: Array<T>;
}

async function list<T> (filter: IGetChatRoomQueryParams): Promise<IChatRoomResponse<T>> {
  const response = await http.get<IChatRoomResponse<T>>('/api/chatroom/list', {
    params: filter
  });

  return response.data;
}

async function getById(id: number) {
  const response = await http.get('/api/chatroom/find', {
    params: {
      id
    }
  });
  return response.data.data;
}

async function save(groupChat: IGroupChat, course_id: number) {
  const response = await http.post('/api/chatroom/save', {...groupChat, course_id: course_id});
  return response.data.data;
}

async function link(users: number[], id: number, type: string) {
  const response = await http.post('/api/chatroom/link', {
    users,
    id,
    type
  });
  return response.data;
}

async function unlink(users: number[], id: number, type: string) {
  const response = await http.post('/api/chatroom/unlink', {
    users,
    id,
    type
  });
  return response.data;
}

async function linkAll(id: number, type: string) {
  const response = await http.post('/api/chatroom/link-all', {
    id,
    type,
  });
  return response.data;
}

async function unlinkAll(id: number, type: string) {
  const response = await http.post('/api/chatroom/unlink-all', {
    id,
    type,
  });
  return response.data;
}

const groupChat = {
  list,
  getById,
  save,
  link,
  unlink,
  linkAll,
  unlinkAll
}

export default groupChat;